// @flow
// GTM + Heap analytics for the legacy app. Mirrors the conventions in
// featureflow-ui/src/utils/gtm.ts and heap.ts so old vs new site usage can be
// compared in the same GA4 property / Heap environment. Heap is loaded via the
// shared GTM container (GTM-TWSVZ2, loaded in public/index.html), so all Heap
// calls guard on window.heap being present.

// Distinguishes this legacy app from featureflow-ui in GA4 and Heap. The
// canonical values are set hostname-based by GTM's "Site Version" RegEx-table
// variable (v1-classic / v2-new) and stamped onto GA4 events and Heap event
// properties by GTM — this constant only mirrors that value into the dataLayer
// for debugging, so it must match the GTM output for this app's hostnames.
const SITE_VERSION = 'v1-classic';

export function pushGTMEvent(event: string, data?: Object) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    siteVersion: SITE_VERSION,
    ...data
  });
}

export function trackPageView(pagePath: string) {
  pushGTMEvent('page_view', {
    pagePath,
    pageTitle: document.title
  });
}

// GA prohibits PII in user_id, so identify by the stable internal id only;
// Heap permits PII such as email as user properties.
export function identifyUser(user: { id: string, attributes: Object }) {
  pushGTMEvent('user_login', {
    userId: user.id,
    organisationId: user.attributes.organisationId,
    organisationName: user.attributes.organisationName
  });
  if (window.heap) {
    window.heap.identify(user.id);
    window.heap.addUserProperties({
      email: user.attributes.email,
      organisationId: user.attributes.organisationId,
      organisationName: user.attributes.organisationName
    });
    // siteVersion is deliberately not set here — GTM's "Heap - Set Site
    // Version" tag owns that event property (same as featureflow-ui)
    window.heap.addEventProperties({
      organisationId: user.attributes.organisationId
    });
  }
}
